export default __webpack_public_path__ + "static/about-80b107afcd6b3ab7e5e4fd365c7cf39d.jpg";